

class CommonList {
  private commonLists: Array<HTMLElement> = [];
  private listItems: Array<HTMLElement> = [];


  constructor() {
    this.commonLists = Array.from(document.querySelectorAll(".list"));
    if (this.commonLists.length === 0) return;
    this.prepareItemsInLists();
  }

  prepareItemsInLists() {
    this.commonLists.forEach((list) => {
      const listBordersData = list.dataset.listOuterBorders;
      const listMarginsData = list.dataset.listOuterMargins;
      const listInnerBordersData = list.dataset.listInnerBorders;
      const listInnerMarginsData = list.dataset.listInnerMargins;
      this.listItems = Array.from(list.querySelectorAll(".list__item"));
      if(this.listItems.length === 0) return;
      
      if(listBordersData || listMarginsData || listInnerBordersData || listInnerMarginsData) {
        this.listItems.forEach((item, index) => {
          this.applyDataToItem(item as HTMLElement, listBordersData || "", this.defineStrategy(listBordersData || ""), index, "outer", "borders");
          this.applyDataToItem(item as HTMLElement, listMarginsData || "", this.defineStrategy(listMarginsData || ""), index, "outer", "marginSides");
          this.applyDataToItem(item as HTMLElement, listInnerBordersData || "", this.defineStrategy(listInnerBordersData || ""), index, "inner", "borders");
          this.applyDataToItem(item as HTMLElement, listInnerMarginsData || "", this.defineStrategy(listInnerMarginsData || ""), index, "inner", "marginSides");
        })
      }
    })
  }
  defineStrategy(data: string) : "even|odd" | "all" | "first|last" {
    if(data.includes("even") || data.includes("odd")) return "even|odd";
    if(data.includes("first") || data.includes("last")) return "first|last";
    return "all";
  }
  applyDataToItem(item: HTMLElement, data: string, strategy: "even|odd" | "all" | "first|last", index: number, type: "outer" | "inner", key: "borders" | "marginSides") {

    if(type === "outer") {
      item.classList.add(`${key === "borders" ? "borders-container" : "margin-receiver"}`);
    }
    if(type === "inner") {
      item.querySelector(".list__item-inner")?.classList.add(`${key === "borders" ? "borders-container" : "margin-receiver"}`);
    }
    if(strategy === "even|odd") {
      let [even, odd] = this.splitEvenOddData(data);
      if(index % 2 === 0) {
        if(type === "outer") {
          even = this.increaseNumberInBorderData(even, Math.floor(index / 2));
          (item as HTMLElement).dataset[key] = even;
        }
        if(type === "inner") {
          even = this.increaseNumberInBorderData(even, Math.floor(index / 2));
          (item.querySelector(".list__item-inner") as HTMLElement).dataset[key] = even;
        }
      } else {
        if(type === "outer") {
          odd = this.increaseNumberInBorderData(odd, Math.floor(index / 2));
          (item as HTMLElement).dataset[key] = odd;
        }
        if(type === "inner") {
          odd = this.increaseNumberInBorderData(odd, Math.floor(index / 2));
          (item.querySelector(".list__item-inner") as HTMLElement).dataset[key] = odd;
        }
      }
    }
    if(strategy === "all") {
      if(type === "outer") {
        data = this.increaseNumberInBorderData(data, index);
        (item as HTMLElement).dataset[key] = this.splitAllData(data);
      }
      if(type === "inner") {
        data = this.increaseNumberInBorderData(data, index);
        (item.querySelector(".list__item-inner") as HTMLElement).dataset[key] = this.splitAllData(data);
      }
    }
    if(strategy === "first|last") {
      let [first, last] = this.splitFirstLastData(data);
      if(index === 0) {
        if(type === "outer") {
          first = this.increaseNumberInBorderData(first, index);
          (item as HTMLElement).dataset[key] = first;
        }
        if(type === "inner") {
          first = this.increaseNumberInBorderData(first, index);
          (item.querySelector(".list__item-inner") as HTMLElement).dataset[key] = first;
        }
      }
      if(index === this.listItems.length - 1) {
        if(type === "outer") {
          last = this.increaseNumberInBorderData(last, index);
          (item as HTMLElement).dataset[key] = last;
        }
        if(type === "inner") {
          last = this.increaseNumberInBorderData(last, index);
          (item.querySelector(".list__item-inner") as HTMLElement).dataset[key] = last;
        }
      }
    }
  }
  

  increaseNumberInBorderData(data:string, increment: number) : string {
    // This function finds every substring in `data` that starts with "n:" and ends with ";".
    // It then increments the number after "n:" by the given `increment` value.
    // We'll use a regular expression to match all such patterns and replace them accordingly.

    // TODO: If there are multiple "n:" patterns in the string, all will be processed.
    // If you want to only process the first occurrence, let me know.

    return data.replace(/n:\s*(\d+);/g, (match, num) => {
      // Increment the found number and reconstruct the pattern
      return `n: ${parseInt(num) + increment};`;
    });
  }
  splitEvenOddData(data:string) : [string, string] {
    const [even, odd] = data.split("},");
    return [
      even.replace("even: {", "").replace("even", "").replace("odd", "").replace("{", "").replace("}", "").trim(),
      odd.replace("odd: {", "").replace("odd", "").replace("even", "").replace("{", "").replace("}", "").trim()
    ]
  }
  splitFirstLastData(data:string) : [string, string] {
    const [first, last] = data.split("},");
    return [
      first.replace("first: {", "").replace("first", "").replace("last", "").replace("{", "").replace("}", "").trim(),
      last.replace("last: {", "").replace("last", "").replace("first", "").replace("{", "").replace("}", "").trim()
    ]
  }
  splitAllData(data:string) : string {
    return data.replace("all: {", "").replace("}", "").trim();
  }

  init() {
  }
}

export default function commonList() {
  return new CommonList();
}